import { render, staticRenderFns } from "./loan-instance-selection.vue?vue&type=template&id=0ba8c97e&scoped=true"
import script from "./loan-instance-selection.vue?vue&type=script&lang=js"
export * from "./loan-instance-selection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba8c97e",
  null
  
)

export default component.exports